import axios from "../Axios";

export default {

  async login(user) {
    var response = await axios.post(`/auth/login`, {
      email: user.email,
      password: user.password,
    },);
    
    if (response.data && response.data.data) {
      const userData = response.data.data;
      if (userData.token) {
        localStorage.setItem("user_free", JSON.stringify(userData));
      }
      return userData;
    }
  },

  // async logout() {
  //   await axios.post(`/auth/logout`, {}, { headers: authHeader() })
  //   localStorage.removeItem('user_free');
  // },
  async logout() {
    const stored = localStorage.getItem('user_free');
    const token = stored ? JSON.parse(stored).token : null;

    if (token) {
      try {
        await axios.post(`/auth/logout`, {}, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          }
        });
      } catch (error) {
        if (error.response?.status === 401) {
          console.log("⚠️ Token expired, clearing localStorage");
        } else {
          throw error;
        }
      }
    }

    localStorage.removeItem('user_free');
    localStorage.removeItem('user_data');
  },
}

